
import React ,{Component} from 'react';
import { bindActionCreators } from 'redux';
import { withRouter }         from 'react-router-dom';
import { connect }            from 'react-redux';
import { Form, Input, Button, Select, message, Spin, Checkbox } from "antd";

// import CreateReport from '../EachAccount/eachaccount';

import wasabiDarkLogo from '../../../assets/logo/wasabi_header_logo_dark.png';

import "./addNewUser.scss";

class AddNewUser extends Component{
    constructor(props) {
        super(props)
        this.state = {
        }
    }
    
    render(){
        const { Option } = Select;
        return(
            <div className="add-new-user-container">
                <div className="content-box">
                    <div className="wasabiLogo">
                        <img alt="wasabi Logo" src={wasabiDarkLogo} />
                    </div>

                    <div className="add-user-form">
                        <Form
                        layout="horizontal"
                        // onSubmit={this.handleSubmit.bind(this)}
                        className="user-form">
                            <Form.Item>
                                <Input 
                                    id="firstName"
                                    placeholder="First Name"
                                    className="user-input"
                                />
                                {/* {getFieldDecorator('user')(
                                    <Input 
                                        placeholder="Email"
                                        className="login-input"
                                    />
                                )} */}
                            </Form.Item>
                            <Form.Item>
                                <Input 
                                    id="lastName"
                                    placeholder="Last Name"
                                    className="user-input"
                                />
                            </Form.Item>
                            <Form.Item>
                                <Input 
                                    id="email"
                                    placeholder="Email"
                                    className="user-input"
                                    type="email"
                                    
                                />
                            </Form.Item>
                            <Form.Item name="accountName" rules={[{ required: true }]}>
                                <Select
                                placeholder="Select Account"
                                // onChange={onGenderChange}
                                allowClear
                                >
                                <Option value="male">CBS</Option>
                                <Option value="female">CloudFlyer</Option>
                                <Option value="other">FOX</Option>
                                </Select>
                            </Form.Item>
                            <Form.Item>
                                <Button
                                    className="user-btn"
                                    type="primary"
                                    size="large"
                                    loading={this.state.loading}
                                    htmlType="submit"
                                    block>
                                    Invite User
                                </Button>
                            </Form.Item>
                        </Form>
                    </div>
                </div>
            </div>
        )
    }
}

export default withRouter(
    connect(
    //   mapStateToProps,
    //   mapDispatchToProps
    )(AddNewUser)
  );